import React, { useMemo } from 'react';
import { sanitizeAlertHtml } from '../alertBodyFormat';
import './alertBody.css';

// Renders an HTML body (an alert's full_text, a hot scam's what_to_know).
// The server sanitized it at save time; it is sanitized again here before it
// touches the DOM. Styling comes from alertBody.css, which the admin editor
// shares, so what an author saw is what renders.
const AlertBody = ({ html }) => {
  const clean = useMemo(() => sanitizeAlertHtml(html), [html]);
  if (!clean) return null;
  // eslint-disable-next-line react/no-danger
  return <div className="alert-body" dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default AlertBody;
